// Slice RTK per `state.language` (string).
// Initial state letta da localStorage (chiave usata da i18next-browser-languagedetector).
// Setter pubblicato come `setLanguage` per back-compat con il vecchio
// `CHANGE_LANGUAGE`. Vedi cdiFiltersSlice.js per il pattern.

import { createSlice } from '@reduxjs/toolkit';

const initialState =
  typeof window !== 'undefined' ? (window.localStorage?.getItem('i18nextLng') ?? null) : null;

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    set: (_state, action) => action.payload ?? null,
  },
});

export const { set: setLanguage } = languageSlice.actions;

export default languageSlice.reducer;
